import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=05cbbe67"
import script from "./Me.vue?vue&type=script&lang=ts"
export * from "./Me.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports